import {Card} from 'antd';
import React from 'react';
import {Route, Switch} from 'react-router';
import EmpresaSociosDetailPage from './_detail';
import EmpresaSocioPage from './socio';

export default function EmpresaSociosPage() {
  return (
      <Card bordered={false}>
        <Switch>
          <Route path="/*/empresas/:empresaId/socios/:id" component={EmpresaSocioPage} />
          <Route path="/*/empresas/:empresaId" component={EmpresaSociosDetailPage} />
        </Switch>
      </Card>);
}
